module.exports = __webpack_public_path__ + "img/golden.9ce16cd6.jpg";